import { useEffect } from "react";
import { useFaceStore } from "@/state/FaceStore";
import { useVoices } from "./useVoices";

export function useVoiceInitialization() {
  const setAvailableVoices = useFaceStore((state) => state.setAvailableVoices);
  const voices = useVoices();

  useEffect(() => {
    setAvailableVoices(voices);
  }, [voices, setAvailableVoices]);
}
